import { useEffect } from 'react';
import { DEFAULT_FAVICON_URL } from '../constants/brandAssets';

export const useFavicon = (faviconBase64) => {
  useEffect(() => {
    const faviconSrc = faviconBase64 || DEFAULT_FAVICON_URL;

    // Önce tüm favicon'ları agresif şekilde kaldır
    const existingFavicons = document.querySelectorAll('link[rel*="icon"], link[rel*="shortcut"], link[rel*="apple-touch-icon"]');
    existingFavicons.forEach(link => {
      link.remove();
    });

    // Favicon'u önceden yükle (cache'e al) - ÖNCE BU
    const faviconImg = new Image();
    faviconImg.onload = () => {
      // Şimdi favicon'ları ekle
      const faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      faviconLink.type = 'image/x-icon';
      faviconLink.href = faviconSrc;
      document.head.appendChild(faviconLink);

      // Shortcut icon
      const shortcutIcon = document.createElement('link');
      shortcutIcon.rel = 'shortcut icon';
      shortcutIcon.href = faviconSrc;
      document.head.appendChild(shortcutIcon);

      // Apple touch icon
      const appleTouchIcon = document.createElement('link');
      appleTouchIcon.rel = 'apple-touch-icon';
      appleTouchIcon.href = faviconSrc;
      document.head.appendChild(appleTouchIcon);

      // 32x32 favicon
      const favicon32 = document.createElement('link');
      favicon32.rel = 'icon';
      favicon32.type = 'image/png';
      favicon32.sizes = '32x32';
      favicon32.href = faviconSrc;
      document.head.appendChild(favicon32);

      // 16x16 favicon
      const favicon16 = document.createElement('link');
      favicon16.rel = 'icon';
      favicon16.type = 'image/png';
      favicon16.sizes = '16x16';
      favicon16.href = faviconSrc;
      document.head.appendChild(favicon16);

      // Favicon'u zorla yenile
      setTimeout(() => {
        const faviconLink = document.querySelector('link[rel="icon"]');
        if (faviconLink) {
          const newHref = faviconSrc + '?t=' + Date.now();
          faviconLink.href = newHref;
        }
      }, 100);
    };
    
    faviconImg.onerror = () => {
      // Favicon yüklenemedi
    };
    
    faviconImg.src = faviconSrc;

  }, [faviconBase64]);
};

